import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Button,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "#fff",
    overflow: "hidden",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const HeaderBox = styled(Box)({
  background: "#F05E4B",
  padding: "25px 20px 30px",
  textAlign: "center",
  position: "relative",
});

const ContentBox = styled(Box)(({ theme }) => ({
  padding: "20px",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "16px",
  },
}));

const ErrorDetailsBox = styled(Box)(({ theme }) => ({
  background: "#f7f7f7",
  padding: "16px",
  borderRadius: "10px",
  textAlign: "center",
  margin: "20px 0",
}));

const Error = ({
  open,
  setOpen,
  ErrorMessage = "Oops! Something went wrong. Please try again.",
  handleOnClick,
  buttonContent,
  CloseButton = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <StyledDialog
      open={open}
      onClose={CloseButton ? () => setOpen(false) : undefined}
      fullWidth
      maxWidth="sm"
    >
      <HeaderBox>
        <ErrorOutlineIcon sx={{ fontSize: "55px", color: "#fff" }} />
        <Typography
          variant="h5"
          fontWeight={700}
          color="white"
          mt={2}
          sx={{ fontSize: isMobile ? "1.2rem" : "1.5rem" }}
        >
          Oops!
        </Typography>

        {CloseButton && (
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </HeaderBox>

      <DialogContent>
        <ContentBox>
          <ErrorDetailsBox>
            <Typography
              variant="body1"
              sx={{
                fontSize: isMobile ? "0.95rem" : "1.05rem",
                fontWeight: 500,
                color: "#333",
              }}
            >
              {ErrorMessage}
            </Typography>
          </ErrorDetailsBox>

          {buttonContent && (
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm="auto">
                <Button
                  variant="contained"
                  fullWidth={isMobile}
                  sx={{
                    borderRadius: "8px",
                    minWidth: "100px",
                    backgroundColor: "#F05E4B",
                    "&:hover": { backgroundColor: "#d94b39" },
                  }}
                  onClick={handleOnClick}
                >
                  {buttonContent}
                </Button>
              </Grid>
            </Grid>
          )}
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
};

export default Error;
